import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridOptions } from "ag-grid/main";
import { ServerConstantsService, DataService, DateUtility,
     CommonUtility, REPMIAGE_GT_REPMAAGE, REPMIAGE_EQ_REPMAAGE, REPENDDT_LT_REPSTDT, REPSTDT_GT_REPENDDT, REPSTDT_GTR_REPENDDT,REPSTDT_INTERVAL_REPENDDT_3M} from '../shared';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { saveAs } from 'file-saver';
import * as jsPDF from 'jspdf';
import { utils, write, WorkBook } from 'xlsx';
import * as moment from 'moment';

@Component({
    selector: 'app-aries-task-report',
    templateUrl: './aries-task-report.component.html',
    styleUrls: ['./aries-task-report.component.scss']
  })
  export class AriesTaskReportComponent implements OnInit {

    private gridOptions: GridOptions;
    ServerConstants: any;

    reportNames: any[];
    providerNames: any[];
    taskTypes: any[];
    
    reportAreas: any[];
    reportCounties: any[];
    reportProviders: any[];
    workParticipationTypes: any[];
    userActionNotificationsMap: any;
    report: any;
    reportMinimumAge: number;
    reportMaximumAge: number;
    reportAreaCode: any;
    reportCounty: any;
    reportProvider: any;
    reportWorkParticipation: any;
    reportBeginDate: any;
    reportEndDate: any;
    taskType:any;
    task:any;
    name: any;
    provider: any;
    providerName:any;
    errorBeginDateField: any;
    errorEndDateField: any;
    errorMoreThanThreeMonthsDates: any;
    isFocused = false;

    taskStatusMulti: Array<any>;
    dropdownSettings: any = {};

    searchPotentialCandicatesRequest: SearchPotentialCandicatesVO;

    areaDisabled: boolean = false;
    countyDisabled: boolean = false;
    providerDisabled: boolean = false;

    dataFound: boolean = false;
    errorMandatoryFields: string;
    errorMinimumMaximumField: string;
    sharedData: any;

    renderedTableContent: AriesReportInfoVO[] = [];
    pdfDocument: boolean = false;
    excelDocument: boolean = false;
    ws: any;

    reportSelectedCountyName : string;
    reportSelectedAreaName : string;
    reportSelectedProviderName : string;
    reportSelectedWorkParticipationName : string;

    //Table variables
    AriesReportInfoRowData:any = [];
    
    AriesReportInfoColumnDefs:any = [];
    gridAriesReportInfoApi: any;
    gridApi: any;
    context: any;
    firstTime: Boolean = true;
    selectedValue: any;
    serviceCounties:any=[];
    serviceCounty:any;
    resCounty:any;
    countiesMap:any;
    counties:any;
    providerDetails:any;
    minError:Boolean = false;
    maxError:Boolean = false;
    rescounties:any;
    rescountiesMap:any;
    private sharedDataMap = new Map<string, string>();

    constructor(private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private dateUtil: DateUtility,
        private data: ReferenceTableService,
        private commonUtil: CommonUtility,
        private refTableService: ReferenceTableService,
        private notificationService: NotificationsService,
        public dataService: DataService,
        private serverConstantsService: ServerConstantsService
) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
}
    ngOnInit() {

        this.sharedData = this.dataService.getSharedDataObject();
        this.getReportNames();
        this.getTaskTypes();
        this.loadUserInformation();
        this.getUserActionNotifications();
        this.loadProviderDetails();
              
        //Sets current report by default on dropdown.
        this.report = 'AR';
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'value',
            textField: 'name',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 3,
            allowSearchFilter: false,
            enableCheckAll: false,
          };
         // this.providerDetails =this.loadProviderDetails();
          this.counties = this.data.getValueFromSharedDataMap('COUNTIES');
          this.countiesMap = this.commonUtil.createMapFromList(this.counties);
          this.rescounties = this.data.getValueFromSharedDataMap('ResidenceCounties');
          this.rescountiesMap = this.commonUtil.createMapFromList(this.rescounties);
    }

    getReportNames() {
        let reports = this.refTableService.getValueFromSharedDataMap("REPORT_NAME");
        this.reportNames = [];
        for (let entry of reports) {
            this.reportNames.push(entry);
        }
    }

    getTaskTypes() {
        let tasks = this.refTableService.getValueFromSharedDataMap("TASKTYPES");
        this.taskTypes = [];
        for (let entry of tasks) {
            this.taskTypes.push(entry);
            //this.taskTypes.push(entry.name);
        }
    }

    loadProviderDetails(){

        this.http.get<any>(this.ServerConstants.REPORT_SERVER_API_URL+'/reportTaskSummary/loadProviderDetails').subscribe(
            data => {
                console.log('loadProviderDetails from backend====',data.type);

                this.providerNames = [];
                for (let entry of data) {
                    //this.providerNames.push(entry['providerName']);
                    this.providerNames.push(entry);
                    }
            }
            );
    
    }
	
    loadUserInformation() {
      this.http.post<any>(this.ServerConstants.REPORT_SERVER_API_URL+'/reportTaskSummary/loaduserdata', null).subscribe(
        data => {
            var role = '';
            if(data.hasOwnProperty('role')) {
                role = data['role'];
            }
  
                if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
                {  
                    if (data.hasOwnProperty('providers')) {
                        let userProviders = data['providers'];
                        var keys = Object.keys(userProviders);
                        this.reportProviders = [];
                        
                        var pickup = new DropdownValues();
                        pickup.value = undefined;
                        pickup.name = "Pick an option";
                        this.reportProviders.push(pickup);                     
                        
                        var pickupAll = new DropdownValues();
                        pickupAll.value = "All"
                        pickupAll.name = "All";
                        this.reportProviders.push(pickupAll);
                        for (let k of keys) {
                            var dv = new DropdownValues();
                            dv.value = k;
                            dv.name = userProviders[k];
                            this.reportProviders.push(dv);
                        }    
                    }
                } else if(this.sharedData.get("roles")[0].id == 5) {
                  if (data.hasOwnProperty('providers')) {
                      let userProviders = data['providers'];
                      var keys = Object.keys(userProviders);
                      this.reportProviders = [];
                      this.reportProviders = Object.values(data['providers']);        
                      this.provider  =  data['providers'][this.sharedData.get("providerId")];
                   }
                   this.providerDisabled = true; 
                } else {
                  if (data.hasOwnProperty('providers')) {
                    let userProviders = data['providers'];
                    var keys = Object.keys(userProviders);
                    this.reportProviders = [];
                    
                    var pickup = new DropdownValues();
                    pickup.value = undefined;
                    pickup.name = "Pick an option";
                    this.reportProviders.push(pickup);                     
                    
                    var pickupAll = new DropdownValues();
                    pickupAll.value = "All"
                    pickupAll.name = "All";
                    this.reportProviders.push(pickupAll);
                    for (let k of keys) {
                        var dv = new DropdownValues();
                        dv.value = k;
                        dv.name = userProviders[k];
                        this.reportProviders.push(dv);
                    }    
                }
            }
    
          }, response => {
            console.log('Get call in error', response);
          }, () => {
    
          });
    }

    onSelectAll(items: any) {
      for (const item of items) {
        this.onItemSelect(item);
      }
      this.isFocused = false;
    }
  
  
    onItemDeselect(deselectStatus) {
  
      this.taskStatusMulti.forEach((status, index) => {
        if (status === deselectStatus) { this.taskStatusMulti.splice(index, 1); }
      });
      event.stopPropagation();
    }
  
    onItemSelect(item: any) {
      this.isFocused = false;
    }

    getReportWorkParticipationTypes() {
        this.workParticipationTypes = this.refTableService.getValueFromSharedDataMap("WORKPARTSTATUS");
    }

    getReportCounties() {
        this.serviceCounties = this.refTableService.getValueFromSharedDataMap("ResidenceCounties");
        this.reportCounties = this.refTableService.getValueFromSharedDataMap("COUNTIES");
        this.serviceCounties.sort(function(a, b) {
            if(a.value != undefined && b.value != undefined){
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            }
         });
         this.reportCounties.sort(function(a, b) {
            if(a.value != undefined && b.value != undefined){
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            }
         });
    }

    getUserActionNotifications(){
        this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    }

    

    onChange(value) {
        if (value == '1: CC') {
            this.router.navigate(["/reports/federalReports/CC"]);
        }

        if (value == '2: CR') {
            this.router.navigate(["/reports/federalReports/CR"]);
        }

        if (value == '3: ER') {
            this.router.navigate(["/reports/federalReports/ER"]);
        }

        if(value == '4: ET') {
            this.router.navigate(["/reports/employment-training-retention"]);
        }

        if(value == '5: SD') {
            this.router.navigate(["reports/monthly-snapshot-details"]);
        }

        if(value == '6: SR') {
            this.router.navigate(["reports/monthly-snapshot-rollup"]);
        }

        if(value == '7: CA') {
            this.router.navigate(["reports/component-activity"]);
        }

        if(value == '8: PC') {
            this.router.navigate(["reports/potential-candidates"]);
        }
        if(value == '9: AR') {
            this.router.navigate(["reports/aries-task"]);
          }
    }

    searchAriesReport(event) {
        this.firstTime = true;
        this.dataFound = true;
       // this.providerName='Workforce Development Board of Eastern Arkansas';
        if (this.reportBeginDate != null) {
            let day = this.reportBeginDate.day;
            let month = this.reportBeginDate.month;
            let year = this.reportBeginDate.year;
            if (day < 10 && month < 10) {
              this.reportBeginDate = year + '/0' + month + '/0' + day;
            }
            else if (day < 10) {
              this.reportBeginDate = year + '/' + month + '/0' + day;
            }
            else if (month < 10) {
              this.reportBeginDate = year + '/0' + month + '/' + day;
            }
            else {
              this.reportBeginDate = year + '/' + month + '/' + day;
            }
          }
    
          if (this.reportEndDate != null) {
                let day = this.reportEndDate.day;
                let month = this.reportEndDate.month;
                let year = this.reportEndDate.year;
                this.reportEndDate = year + '/' + month + '/' + day;
                if (day < 10 && month < 10) {
                this.reportEndDate = year + '/0' + month + '/0' + day;
                }
                else if (day < 10) {
                this.reportEndDate = year + '/' + month + '/0' + day;
                }
                else if (month < 10) {
                this.reportEndDate = year + '/0' + month + '/' + day;
                }
                else {
                this.reportEndDate = year + '/' + month + '/' + day;
                }
            }
        let request ={
            taskType:this.taskStatusMulti,
            providerName:this.provider,
            reportBeginDate:this.reportBeginDate,
            reportEndDate:this.reportEndDate
              
        }   
        console.log('Aries Report request to backend===',request)     

            this.loadAriesReportData(request);
    }

    validDates() {
      if (this.reportBeginDate !== undefined
        && this.reportBeginDate !== null
        && this.reportEndDate !== undefined
        && this.reportEndDate !== null) {
        const startDt = new Date(this.reportBeginDate.year,
          this.reportBeginDate.month - 1,
          this.reportBeginDate.day);
        const endDt = new Date(this.reportEndDate.year,
          this.reportEndDate.month - 1,
          this.reportEndDate.day)
        if (startDt > endDt) {
          this.errorEndDateField = REPSTDT_GTR_REPENDDT;
          return false;
        } 
        if (endDt < startDt) {
          this.errorEndDateField = REPENDDT_LT_REPSTDT;
          return false;
        }
        else {
          this.errorEndDateField = null;
        }
        // const nextYear = new Date(startDt);
        // nextYear.setFullYear(nextYear.getFullYear() + 1)
        // if(endDt >= nextYear)
        // {
        //   this.errorEndDateField = REPSTDT_GT_REPENDDT;
        //   return false;
        // }
      } 
      // else if(this.report=='CR') {
      //   return (this.checkBeginDate() && this.checkEndDate());
      // }
      return true;
    }
  
    checkBeginDate() {
      if (this.reportBeginDate == undefined
        || this.reportBeginDate == null) {
          console.log("Missing Begin Date");
        this.errorBeginDateField = "Missing Begin Date";
        return false;
      }
      console.log("No Missing Begin Date");
      this.errorBeginDateField = null;
      return true;
    }
  
    checkEndDate() {
      if (this.reportEndDate == undefined
        || this.reportEndDate == null) {
        this.errorEndDateField = "Missing End Date";
        return false;
      }
      this.errorEndDateField = null;
      return true;
    }
    
    loadAriesReportData(request) {
             this.http.post<SearchPotentialCandicatesVO>(this.ServerConstants.REPORT_SERVER_API_URL+'/reportTaskSummary/loadariestask', request).subscribe(
          (data:SearchPotentialCandicatesVO ) => {

            console.log('Aries Report response from backen',data);
            this.pdfDocument = true;
            this.excelDocument = true;
            this.getAriesReportColumnDefinitions();
            
            this.AriesReportInfoRowData = data;
            for (let entry of  this.AriesReportInfoRowData) {
              entry.createdDt=entry.createdDt.substring(0,10);
              entry.createdDt=moment(entry.createdDt).format('MM/DD/YYYY');

            }
           
            this.renderedTableContent = this.AriesReportInfoRowData.slice();

           
          }, response => {
            //this.notificationService.error('Report Summary', this.userActionNotificationsMap.ERROR);
          }, () => {
    
    
          });

    }

    onChangeArea(value) {
        var valueSelected = value.split(':')
        var id = valueSelected[0];
        this.reportSelectedAreaName = this.reportAreas[id].name;
    }

    onChangeCounty(value) {
        var valueSelected = value.split(':')
        var id = valueSelected[0];
        this.reportSelectedCountyName = this.reportCounties[id].name;
    }

    onChangeProvider(value) {
        var valueSelected = value.split(':')
        var id = valueSelected[0];
        this.reportSelectedProviderName = this.reportProviders[id].name;
    }

    onChangeWorkParticipation(value) {
        var valueSelected = value.split(':')
        var id = valueSelected[0];
        this.reportSelectedWorkParticipationName = this.workParticipationTypes[id].name;
    }

    getAllRows() {
          let rowData = this.renderedTableContent.map(a => Object.assign({}, a));;
        return rowData;
      }
    downloadnodePDF(event){
        var width = 420;
        var height = 220;
        var temp = [420, 220];
        var doc = new jsPDF("p", "mm", "a1");
        var rows = [];
        const col = this.AriesReportInfoColumnDefs.map(head => head.headerName);
        const rowCountModNew = this.getAllRows();
        rowCountModNew.forEach(element => {
            var row=[element.providerName,
                     element.ssn, 
                     element.firstName,
                     element.lastName,
                     element.taskType,
                     moment(element.createdDt.substring(0,10)).format('MM/DD/YYYY') ,
                    ];
            rows.push(row);
        });

        doc.autoTable(col, rows, {margin: {top: 25}});
        doc.save('Aries-Report.pdf');
      
    }


   
    downloadPDFKeydown(event) {
        if (event.keyCode === 32 || event.keyCode === 13) {
          this.downloadnodePDF(event);
        }
      }
    
    downloadExcel(value) {       
        let contentData = this.getAllRows();
         contentData.forEach(element => {

            if (element.createdDt !== undefined && element.createdDt!== null) {
              //element.createdDt=element.createdDt.substring(0,10) ;
              element.createdDt==element.createdDt.substring(0,10);
              element.createdDt=moment(element.createdDt).format('MM/DD/YYYY') ;
            }           
                        
         });
        let contentColumns = this.AriesReportInfoColumnDefs;
        this.ws = utils.json_to_sheet(contentData);
        const ws_name = 'Aries Report';
        const wb: WorkBook = { SheetNames: [], Sheets: {} };
        wb.SheetNames.push(ws_name);
        wb.Sheets[ws_name] = this.ws;
        const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
        const buf = new ArrayBuffer(wbout.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== wbout.length; ++i) {
          view[i] = wbout.charCodeAt(i) & 0xFF;
        };
        saveAs(new Blob([buf], { type: 'application/octet-stream' }), 'Aries Report.xlsx');
    }
    
    downloadExcelKeydown(event) {
        if (event.keyCode === 32 || event.keyCode === 13) {
          this.downloadExcel(event);
        }
      }

    checkMandatoryParameters() {

        if(( this.reportProvider !== undefined
            && this.reportProvider !== null)) {

                if (this.reportCounty !== undefined
                && this.reportCounty !== null) {
                    this.errorMandatoryFields =   null;  
                    return true; 
                } else if (this.reportAreaCode !== undefined
                    && this.reportAreaCode !== null) {
                    this.errorMandatoryFields =   null;  
                    return true;  
                } 
        } 
        this.errorMandatoryFields = "Please select Provider and County (or Area).";
        return false;
    }
    getServiceCounty(params) {
        const that = params.context.component;
    
        return that.countiesMap.get(params.data.serviceCounty + '');
      }
      getResCounty(params) {
        const that = params.context.component;
    
        return that.rescountiesMap.get(params.data.resCounty + '');
      }

    gridClick() {
        this.firstTime = false;
    }

    setAriesReportDisplayedRowAtIndex() {
        // get the first row
        const index = this.gridAriesReportInfoApi.getFirstDisplayedRow();
        const rowNode = this.gridAriesReportInfoApi.getDisplayedRowAtIndex(index);
        // scrolls to the first row
        // scrolls to the first column
        const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
        this.gridAriesReportInfoApi.ensureColumnVisible(firstCol);
        // sets focus into the first grid cell
        this.gridAriesReportInfoApi.setFocusedCell(index, firstCol);
    }

    setDisplayedRowAtIndex() {
        // get the first row
        const index = this.gridApi.getFirstDisplayedRow();
        const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
        // scrolls to the first row
        //this.gridApi.ensureIndexVisible(0, 'top');
        // scrolls to the first column
        const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
        this.gridApi.ensureColumnVisible(firstCol);
        // sets focus into the first grid cell
        this.gridApi.setFocusedCell(index, firstCol);
    }

    onPaginationChanged(event) {
        if (this.firstTime) {
          return;
        } else {
          if ( this.selectedValue === 1 || this.selectedValue === 2 ) {
            if ( this.gridApi ) {
              this.setDisplayedRowAtIndex();
            }
          } else if ( this.selectedValue === 3) {
            if( this.gridAriesReportInfoApi ) {
              this.setAriesReportDisplayedRowAtIndex();
            }
          }
        }
      }
 

    onAriesReportGridReady(params) {
        this.gridAriesReportInfoApi = params.api;
        this.gridOptions.api = params.api;
        params.api.setGridAutoHeight(true);
        params.api.sizeColumnsToFit();
    }
    getPersonIdLink(params) {
        const that = params.context.component;
        const element = document.createElement('a');
        element.innerHTML = params.data.ssn;
        element.addEventListener('click', () => {
            that.dataService.addValueToSharedDataMap('SSN_SEARCH', params.data.ssn);
            that.dataService.addValueToSharedDataMap('UNIVERSE_SEARCH', true);
            that.router.navigate(['/universe/personSummary']);
        });
        element.addEventListener('keydown', (event) => {
          if (event.keyCode === 13 || event.keyCode === 32) {
            that.dataService.addValueToSharedDataMap('SSN_SEARCH', params.data.ssn);
            that.dataService.addValueToSharedDataMap('UNIVERSE_SEARCH', true);
            that.router.navigate(['/universe/personSummary']);
          }
        });
        element.setAttribute('tabindex', '0');
        return element;
      }

    getAriesReportColumnDefinitions() {
        this.AriesReportInfoColumnDefs = [
            {
                headerName: 'Provider Name',
                field: 'providerName'
            },
            {
                headerName: 'SSN',
                cellRenderer: this.getPersonIdLink,
                field: 'ssn'
            },                                  
            {
                headerName: 'First Name',
                field: 'firstName'
            },
            {
                headerName: 'Last Name',
                field: 'lastName'
            },
            {
                headerName: 'Task Type',
                field: 'taskType'
            },
            {
                headerName: 'Created Date',
                field: 'createdDt'
            }          
            
         
        ];
        this.context = {
          component: this
        }
      }
  
      //end class
    }

export class DropdownValues {
    constructor(  
        public name?:string,
        public value?:string,
    ) {}
}

export class SearchPotentialCandicatesVO {
    constructor(
        public providerName?:string,
        public ssn?:string,
        public firstName?:string,
        public lastName?:string,
        public taskType?:string,
        public createdDt?: string,
    ){}
} 

export class AriesReportInfoVO {
    constructor(
        public providerName?:string,
        public ssn?:string,
        public firstName?:string,
        public lastName?:string,
        public taskType?:string,
        public createdDt?: string,
    ) {}
}






// WEBPACK FOOTER //
// ./src/app/aries-task-report/aries-task-report.component.ts